export const technologies = {
  firebase: {
    iconUrl: '/images/technologies/firebase.svg',
    title: 'Firebase (Auth + Firestore)',
  },
  gatsby: {
    iconUrl: '/images/technologies/gatsby.svg',
    title: 'Gatsby',
  },
  golang: {
    iconUrl: '/images/technologies/golang.svg',
    title: 'Go',
  },
  graphql: {
    iconUrl: '/images/technologies/graphql.svg',
    title: 'GraphQL',
  },
  htmx: {
    iconUrl: '/images/technologies/htmx.jpg',
    title: 'htmx',
  },
  mongodb: {
    iconUrl: '/images/technologies/mongodb.svg',
    title: 'MongoDB',
  },
  nextjs: {
    iconUrl: '/images/technologies/next-js.svg',
    title: 'Next.js',
  },
  rails: {
    iconUrl: '/images/technologies/rails.svg',
    title: 'Ruby on Rails',
  },
  react: {
    iconUrl: '/images/technologies/react.svg',
    title: 'React',
  },
  redux: {
    iconUrl: '/images/technologies/redux.svg',
    title: 'Redux',
  },
  sanity: {
    iconUrl: '/images/technologies/sanity.svg',
    title: 'Sanity',
  },
  sqlite: {
    iconUrl: '/images/technologies/sqlite.svg',
    title: 'SQLite',
  },
  styledComponents: {
    iconUrl: '/images/technologies/styled-components.svg',
    title: 'Styled Components',
  },
  svelte: {
    iconUrl: '/images/technologies/svelte.svg',
    title: 'Svelte',
  },
  tailwind: {
    iconUrl: '/images/technologies/tailwind.svg',
    title: 'Tailwind CSS',
  },
  typescript: {
    iconUrl: '/images/technologies/typescript.svg',
    title: 'TypeScript',
  },
  webpack: {
    iconUrl: '/images/technologies/webpack.svg',
    title: 'webpack',
  },
};
